module.exports = __webpack_public_path__ + "img/image 1132@2x.6bc1a3b5.png";